module.exports = new __parcel__URL__("so2--dataset-cover.d9f27f27.jpg").toString();